import { Check, Clock, Edit } from 'react-feather';
import { isPast } from 'date-fns';
import { useTranslation } from 'react-i18next';
import UI from '../../../common/UI';
import useLocale from '../../../common/useLocale';

interface MessageStatusLabelProps {
  message: {
    scheduled_at?: string | null;
    remaining_count: number;
    last_sent_at?: string | null;
    draft: boolean;
  };
}

const MessageStatusLabel = ({ message }: MessageStatusLabelProps) => {
  const { t } = useTranslation();
  const { formatDate, parseDate } = useLocale();

  const scheduledAt = message.scheduled_at
    ? parseDate(message.scheduled_at, { timezone: 'UTC' })
    : undefined;

  if (message.remaining_count > 0 || isPast(scheduledAt)) {
    return (
      <UI.Label sc={{ background: 'secondary', color: 'white', small: true }}>
        <UI.Icon>
          <UI.Loader sc={{ size: 12, brand: 'white' }} />
        </UI.Icon>
        {' '}
        {t('sending')}
      </UI.Label>
    );
  }

  if (message.scheduled_at) {
    return (
      <UI.Label sc={{ background: 'secondary.50', color: 'secondary.600', small: true }}>
        <UI.Icon>
          <Clock />
        </UI.Icon>
        {' '}
        {t('scheduled_date', {
          date: formatDate(
            parseDate(message.scheduled_at, { timezone: 'UTC' }),
            { format: 'display_compact_date_time' },
          ),
        })}
      </UI.Label>
    );
  }

  if (message.last_sent_at) {
    return (
      <UI.Label sc={{ background: 'primary.50', color: 'primary.900', small: true }}>
        <UI.Icon>
          <Check />
        </UI.Icon>
        {' '}
        {t('sent_date', {
          date: formatDate(
            parseDate(message.last_sent_at, { timezone: 'UTC' }),
            { format: 'display_compact_date_time' })
          ,
        })}
      </UI.Label>
    );
  }

  if (message.draft) {
    return (
      <UI.Label sc={{ background: 'gray.100', color: 'gray.600', small: true }}>
        <UI.Icon>
          <Edit />
        </UI.Icon>
        {' '}
        {t('draft')}
      </UI.Label>
    );
  }

  return (
    <></>
  );
};

export default MessageStatusLabel;
